module.exports = __webpack_public_path__ + "static/01-36596dfb3007ee31b3e8347061c4f603.jpg";